<div class="notification-menu" (keydown.escape)="close()">
  <button
    class="notif-btn"
    (click)="toggle()"
    [attr.aria-expanded]="open()"
    aria-haspopup="true"
    [attr.aria-label]="unreadCount() > 0 ? unreadCount() + ' notificações não lidas' : 'Notificações'"
    title="Notificações">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <path d="M9 2C6.239 2 4 4.239 4 7V11L2.5 13H15.5L14 11V7C14 4.239 11.761 2 9 2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M7.5 13C7.5 13.828 8.172 14.5 9 14.5C9.828 14.5 10.5 13.828 10.5 13" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
    </svg>
    @if (unreadCount() > 0) {
      <span class="notif-badge" aria-hidden="true">{{ badgeLabel() }}</span>
    }
  </button>

  @if (open()) {
    <div class="menu-backdrop" (click)="close()" aria-hidden="true"></div>

    <div class="notif-dropdown" role="menu" aria-label="Notificações">
      <div class="notif-dropdown-header">Notificações</div>
      <div class="notif-dropdown-divider" role="separator"></div>

      @if (items().length === 0) {
        <p class="notif-empty">Nenhuma notificação por aqui.</p>
      } @else {
        <ul class="notif-list" role="none">
          @for (item of items(); track item.id) {
            <li role="none">
              <div class="notif-item" [class.unread]="!item.read" role="menuitem">
                <span class="notif-item-title">{{ item.title }}</span>
                <span class="notif-item-message">{{ item.message }}</span>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
